import {  Component } from '@angular/core';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';

@Component({
  selector: 'sura-mobility-loader',
  standalone: true,
  imports: [BannerAppComponent],
  templateUrl: './mobility-loader.component.html',
  styleUrl: './mobility-loader.component.scss',
})
export class MobilityLoaderComponent { }
